import { useDisclosure } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { AddIcon, RanaButton } from "@nens/ranalib";

import { FileAddModal } from "./file-add-modal";

export function PublicationDetailFileAdd() {
  const disclosure = useDisclosure();

  return (
    <>
      <RanaButton leftIcon={<AddIcon />} ml="auto" variant="secondary" onClick={disclosure.onOpen}>
        <FormattedMessage id="button.add_file" defaultMessage="Add files" />
      </RanaButton>
      <FileAddModal {...disclosure} />
    </>
  );
}
